import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";

import '../../css/sismo_sentido.css';
import Contexto from '../comun/Contexto';
import sismosDummy from "../ultimos_sismos.json";

export default function SelectorSismos(props) {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /* Estado */
    const [indiceSeleccionado, setIndiceSeleccionado] = useState();
    const [sismos, setSismos] = useState([]);
    
    const campos = [/*"ID",*/"fecha"];

    /* Efectos */
    useEffect(() => {
        const traerSismos = async () => {  
            console.log("urlBaseRest")          
            console.log(urlBaseRest)          
            const res = await axios(urlBaseRest+"ultimos_sismos");           
            setSismos(res.data);            
        };
        if (urlBaseRest && urlBaseRest!= null)
            traerSismos();       
    }, []);

    useEffect(()=> {
        if (sismos.length> 0)
        seleccionarSismo(0)
    }, [sismos]);

    /* Modificacion de estado */
    const seleccionarSismo = (index) => {
        setIndiceSeleccionado(index);
        props.setIdSismo(sismos[index].ID)
    }

    /* Render */
    return (        
        <div>
        <div className="SelectorEncabezadoTabla">FECHA Y HORA</div>
        <div className="SelectorContenedor">	
       
        <table id="tablaSismos" className="Width100" style={{margin: "0 auto"}}>
			<tbody>
                {
                sismos.map((sismo, index) => {                  
                    return (
                        <tr
                        className={index===indiceSeleccionado ? "SelectorFilaSeleccionada" : "SelectorFilaNoSeleccionada"}
                        onClick={()=>{seleccionarSismo(index)}
                        }
                        key={index}>  
                            {campos.map((campo, index2)=> {
                                return (
                                    <td 
                                    key={index2}>{sismo[campo]}</td>
                                );
                            })}                            
                        </tr>
                    );
                })
                }
            </tbody>
		</table>
        </div>
        </div>
    );
}